import Vue from "vue";
import {
  Slider,
  Input,
  Notification,
  Form,
  FormItem,
  InfiniteScroll,
  InputNumber,
  Tooltip,
  Tabs,
  TabPane,
  Select,
  Option,
  Pagination,
  Table,
  TableColumn,
} from "element-ui";

Vue.use(Slider);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(InfiniteScroll);
Vue.use(InputNumber);
Vue.use(Tooltip);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Select);
Vue.use(Option);
Vue.use(Pagination);
Vue.use(Table);
Vue.use(TableColumn);

Vue.prototype.$notify = Notification;
